import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select

function Ledger() {
    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [selectedOption, setSelectedOption] = useState('itemWise');
    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [customerId, setCustomer] = useState('');
    const { isAuthenticated, companyId, permissions, token, logout } = useAuth();


    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchTableData();
        //fetchCustomerData();
    }, [isAuthenticated, companyId, token, logout]);

    //Route
    const [routeOptions, setRouteOptions] = useState([]);
    const [selectedRoute, setSelectedRoute] = useState(null);


    const fetchRouteTypes = async () => {
        try {
            const response = await fetchData('RouteApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(route => ({
                    value: route.id,
                    label: route.name
                }));
                setRouteOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    useEffect(() => {
        fetchRouteTypes();
    }, []);


    useEffect(() => {
        if (customerId) {
            fetchTableData();
        }
    }, [customerId, fromDate, toDate, companyId]); // Added dependencies to ensure re-fetching on date change



    const handleCustomerSelect = (selectedOption) => {
        setSelectedCustomer(selectedOption);
        const customerId = selectedOption ? selectedOption.value : '';
        setCustomer(customerId);
        setDataItem([]);
        console.log('Selected Customer ID:', customerId); // Debugging
    };

    const handleRouteWiseCustomerChange = async (selectedOption) => {
        setSelectedRoute(selectedOption);
        setSelectedCustomer(null); // Reset customer selection
        try {
            const response = await fetchData('CustomerApi', `/${companyId}/${selectedOption.value}`, token);
            if (response.responseCode === '1111') {
                const customerOptions = response.response_data.map(customer => ({
                    value: customer.id,
                    label: customer.name
                }));
                setCustomerOptions(customerOptions);
            }
        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };




    const fetchTableData = async () => {

        setDataItem([])
        try {
            //const response = await fetchData('LedgerReportAPI', `/${fromDate}/${toDate}/${companyId}/${customerId}`, token);
            const response = await fetchData('LedgerReportAPI', `/${fromDate}/${toDate}/${companyId}/${customerId}`, token);

            if (response.responseCode === '1111') {
                setDataItem(response.response_data);

            }
        } catch (error) {
            console.error('Error fetching Packing Slip Details:', error);
        }

    };

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setFromDate(selectedDate);
    };

    // Similar function for toDate
    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setToDate(selectedDate);
    };

    const hasReadReportPermission = permissions.includes('Read Reports');

    const handleChange = (event) => {
        setSelectedOption(event.target.value);
    };



    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataBill = dataBill.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    const handleExportExcel = () => {
        const excelData = [];

        // Ensure selectedCustomer is handled properly
        const customerLabel = selectedCustomer ? selectedCustomer.label : 'All Customers';

        // Add header row
        const headerCaption = [`Ledger for ${customerLabel} From : ${formatDate(fromDate)} To : ${formatDate(toDate)}`];
        excelData.push(headerCaption);

        const headerRow = ['Date', 'Description', 'Bill Amount', 'Debit', 'Credit'];
        excelData.push(headerRow);

        // Add data rows
        filteredDataItem.forEach((rowData) => {
            const dataRow = [];
            if (rowData.description === 'Opening Balance' || rowData.description === 'Closing Balance' || rowData.description === 'Total') {
                dataRow.push('', rowData.description, '', rowData.debit, rowData.credit);
            } else {
                dataRow.push(formatDate(rowData.date1), rowData.description, rowData.billAmount, rowData.debit, rowData.credit);
            }
            excelData.push(dataRow);
        });

        // Export logic (assuming you are using a library like 'xlsx' for Excel export)
        const worksheet = XLSX.utils.aoa_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Ledger');
        XLSX.writeFile(workbook, `Ledger_${customerLabel.replace(/\s/g, '_')}.xlsx`);
    };

    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        if (!printWindow) {
            console.error('Failed to open print window.');
            return;
        }

        // Ensure selectedCustomer is handled properly
        const customerLabel = selectedCustomer ? selectedCustomer.label : 'All Customers';
        const title = `Ledger for ${customerLabel} From: ${formatDate(fromDate)} To: ${formatDate(toDate)}`;

        // Begin writing to the print window
        printWindow.document.write('<html><head><title>' + title + '</title></head><body>');

        // Add title to the body as a heading
        printWindow.document.write(`<h5 style="font-family: Times New Roman; font-size: 22px;">${title}</h5>`);
        printWindow.document.write(`<h5 style="font-family: Times New Roman; font-size: 18px;">From: ${formatDate(fromDate)} To: ${formatDate(toDate)}</h5>`);

        printWindow.document.write('<table style="border-collapse: collapse; width: 100%;">');
        printWindow.document.write('<thead style="background-color: #f3f3f3;">');
        printWindow.document.write('<tr>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Date</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Description</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Bill Amount</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Debit</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Credit</th>');
        printWindow.document.write('</tr>');
        printWindow.document.write('</thead>');
        printWindow.document.write('<tbody>');

        filteredDataItem.forEach((rowData, index) => {
            printWindow.document.write('<tr>');

            if (rowData.description === 'Opening Balance' || rowData.description === 'Closing Balance' || rowData.description === 'Total') {
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; font-weight: bolder;"></td>`);
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; font-weight: bolder;">${rowData.description}</td>`);
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; font-weight: bolder;"></td>`);
            } else {
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${formatDate(rowData.date1)}</td>`);
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.description}</td>`);
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.billAmount}</td>`);
            }

            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.debit}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.credit}</td>`);

            printWindow.document.write('</tr>');
        });

        printWindow.document.write('</tbody>');
        printWindow.document.write('</table>');
        printWindow.document.write('</body></html>');

        printWindow.document.close();
        printWindow.print();
    };


    return (

        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '10px' }}>

            <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Arial', marginTop: '10px', fontSize: '20px' }}>
                Customer Ledger
            </h6>
            <br />
            <div style={{ display: 'flex', flexWrap: 'nowrap', marginBottom: '16px', marginLeft: '5px' }}>
                <div style={{ flex: '3', maxWidth: '17%', paddingRight: '8px', marginBottom: '0', marginTop: '-15px' }}>
                    <label style={{ display: 'block', color: 'Black', fontSize: '14px', fontWeight: 'bold', marginBottom: '8px' }} htmlFor="Route">
                        Route <span className="text-red-500">*</span>
                    </label>
                    <Select
                        value={selectedRoute}
                        onChange={handleRouteWiseCustomerChange}

                        options={routeOptions}
                        placeholder="Select Route"
                        isSearchable
                    />
                </div>

                <div style={{ flex: '3', maxWidth: '25%', paddingRight: '8px', marginBottom: '0', marginTop: '-15px' }}>
                    <label style={{ display: 'block', color: 'Black', fontSize: '14px', fontWeight: 'bold', marginBottom: '8px' }} htmlFor="party">
                        Customer <span style={{ color: 'red' }}>*</span>
                    </label>
                    <Select
                        options={customerOptions}
                        value={selectedCustomer}
                        onChange={handleCustomerSelect}
                        placeholder="Select a customer"
                        style={{ width: '100%' }}
                    />
                </div>

                <div style={{ flex: '2', maxWidth: '12%', paddingRight: '8px', marginBottom: '0', marginTop: '-15px' }}>
                    <label style={{ display: 'block', color: 'Black', fontSize: '14px', fontWeight: 'bold', marginBottom: '8px' }} htmlFor="fromDate">
                        From Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                    />
                </div>

                <div style={{ flex: '2', maxWidth: '12%', marginLeft: '8px', marginBottom: '0', marginTop: '-15px' }}>
                    <label style={{ display: 'block', color: 'Black', fontSize: '14px', fontWeight: 'bold', marginBottom: '8px' }} htmlFor="toDate">
                        To Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={toDate} onChange={handleToDateChange}
                    />
                </div>
                
                <Button
                    style={{
                        background: 'linear-gradient(to right, #A8A196,#A8A196)',
                        color: 'black',
                        fontWeight: 'bolder',
                        textTransform: 'none',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                        maxHeight: '30px',
                        marginLeft: '15px',
                        marginTop: '1.0%'

                    }}
                    onClick={fetchTableData}

                >
                    <RefreshIcon style={{ color: 'white', fontWeight: 'bolder' }} />
                    <b style={{ color: 'white' }}>Refresh</b>
                </Button>

                <Button
                    style={{
                        background: 'linear-gradient(to right, #4D455D,#4D455D)',
                        color: 'black',
                        fontWeight: 'bolder',
                        textTransform: 'none',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                        maxHeight: '30px',
                        marginLeft: '15px',
                        marginTop: '1.0%'

                    }}
                    onClick={handleExportExcel}

                >
                    <FeedIcon style={{ color: 'white', fontWeight: 'bolder' }} />
                    <b style={{ color: 'white' }}>Excel</b>
                </Button>
            </div>


            <div className='w-full mb-5 flex' style={{ maxHeight: '400px', overflowY: 'auto' }}>

                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: '#D8D9CF' }}>
                            <TableRow>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '14px', color: 'black', padding: '5px', fontWeight: 'bold' }}>Date</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '14px', color: 'black', padding: '5px', fontWeight: 'bold' }}>Description</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '14px', color: 'black', padding: '5px', fontWeight: 'bold' }}>Bill Amount</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '14px', color: 'black', textAlign: 'right', padding: '5px', fontWeight: 'bold' }}>Debit</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '14px', color: 'black', textAlign: 'right', padding: '5px', fontWeight: 'bold' }}>Credit</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredDataItem.map((data, index) => (
                                <TableRow key={data.id} sx={data.description === 'Opening Balance' || data.description === 'Closing Balance' || data.description === 'Total' ? { backgroundColor: '#f0f0f0' } : null}>

                                    {data.description === 'Opening Balance' || data.description === 'Closing Balance' || data.description === 'Total' ? (

                                        <TableCell sx={{ fontSize: '14px', padding: '7px', fontWeight: 'bolder' }}></TableCell>
                                    ) : (
                                        <TableCell sx={{ fontSize: '14px', padding: '7px' }}>{formatDate(data.date1)}</TableCell>
                                    )}


                                    <TableCell
                                        sx={{
                                            fontSize: '15px',
                                            height: '30px',
                                            padding: '11px',
                                            fontWeight:
                                                data.description === 'Opening Balance' ||
                                                    data.description === 'Closing Balance' ||
                                                    data.description === 'Total'
                                                    ? 'bolder'
                                                    : 'normal',
                                        }}
                                    >
                                        {data.tbl === 'Sale' ? (
                                            <a
                                                href={`/SaleDetails/${data.id}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ color: 'darkgreen' }}
                                            >
                                                {data.description}
                                            </a>
                                        ) : data.tbl === 'Sale Return' ? (
                                            <a
                                                href={`/SaleReturnDetails/${data.id}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ color: 'red' }}
                                            >
                                                {data.description}
                                            </a>
                                        ) : (
                                            data.description
                                        )}
                                    </TableCell>

                                    <TableCell sx={{ fontSize: '15px', height: '30px', padding: '11px', fontWeight: data.description === 'Opening Balance' || data.description === 'Closing Balance' || data.description === 'Total' ? 'bolder' : 'normal' }}>{data.billAmount === 0 ? '' : data.billAmount}</TableCell>
                                    <TableCell sx={{ fontSize: '15px', height: '30px', padding: '11px', textAlign: 'right', fontWeight: data.description === 'Opening Balance' || data.description === 'Closing Balance' || data.description === 'Total' ? 'bolder' : 'normal' }}> {data.debit != null ? data.debit.toFixed(2) : ''}</TableCell>
                                    <TableCell sx={{ fontSize: '15px', height: '30px', padding: '11px', textAlign: 'right', fontWeight: data.description === 'Opening Balance' || data.description === 'Closing Balance' || data.description === 'Total' ? 'bolder' : 'normal' }}> {data.credit != null ? data.credit.toFixed(2) : ''}</TableCell>

                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>



            </div>
        </div>
    );
}

export default Ledger;
